<mat-form-field class="full-width" subscriptSizing="dynamic">
  <mat-label>{{placeholder ? (placeholder | translate) : ''}}</mat-label>
  <mat-select [(ngModel)]="value" (selectionChange)="valueChanged(value)" [disabled]="disabled" [matTooltip]="tooltip">
    @for (item of items; track item) {
      <mat-option
        [value]="item.id"
        class="mat-option-text {{'filter-' + name}} {{'option-' + item.id}}"
        >
        {{item.name | translate}}
      </mat-option>
    }
  </mat-select>
  @if (showClearButton && value) {
    <button matSuffix mat-icon-button class="reset-btn" aria-label="Clear"
      (click)="clearValue(); $event.stopPropagation()">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>